export class GlobalConstants {

  public static privacypolicy = 'https://lukas-kraemer.de/datenschutzerklaerung';
  public static imprimt = 'https://lukas-kraemer.de/impressum-de';
  public static sitetitle = 'HA Analysis Tool';
  public static apiUrl = 'https://' + document.location.hostname + '/api/';
}
